import { categoryListUrl } from '@/urls'
import { isOnStaging } from '@/util/helpers'

export const WORLD_CUP_CATEGORY_ID = isOnStaging() ? 2321 : 3671
export const WORLD_CUP_SLUG_SEGMENT = 'fifa-world-cup-2026'
export const WORLD_CUP_PATH = `/markets/sports/football/${WORLD_CUP_SLUG_SEGMENT}/${WORLD_CUP_CATEGORY_ID}`
export const WORLD_CUP_GROUP_SLUG_PREFIX = 'group-'

export function worldCupCoverUrl() {
  return typeof import.meta !== 'undefined' && import.meta.env?.VITE_FUTUUR_STATIC_URL
    ? `${import.meta.env.VITE_FUTUUR_STATIC_URL}/img/meta/world-cup.png`
    : ''
}

export function isWorldCupCategory({ categoryId, pathname }) {
  return (
    String(categoryId) === String(WORLD_CUP_CATEGORY_ID) ||
    pathname?.includes(WORLD_CUP_SLUG_SEGMENT)
  )
}

export function isWorldCupGroupSlug(slug) {
  return slug?.startsWith(WORLD_CUP_GROUP_SLUG_PREFIX)
}

export function isWorldCupGroupPage({ pathname }) {
  if (!pathname?.includes(WORLD_CUP_SLUG_SEGMENT)) return false
  const segments = pathname.split('/').filter(Boolean)
  const wcIdx = segments.indexOf(WORLD_CUP_SLUG_SEGMENT)
  return wcIdx !== -1 && segments[wcIdx + 1] && isWorldCupGroupSlug(segments[wcIdx + 1])
}

export function worldCupGroupSlug(letter) {
  return `${WORLD_CUP_GROUP_SLUG_PREFIX}${String(letter).toLowerCase()}`
}

export function worldCupGroupLetterFromSlug(slug) {
  if (!isWorldCupGroupSlug(slug)) return null
  const letter = slug.slice(WORLD_CUP_GROUP_SLUG_PREFIX.length)
  return letter ? letter.toUpperCase() : null
}

export function worldCupGroupLetterFromCategory(category) {
  return worldCupGroupLetterFromSlug(category?.slug)
}

export function worldCupCategoryUrl(localePrefix = '') {
  return `${localePrefix}${WORLD_CUP_PATH}`
}

export function worldCupGroupUrl(category, localePrefix = '') {
  if (!category) return null
  return `${localePrefix}${categoryListUrl(category)}`
}

export function findWorldCupGroupCategory(letter, groupCategories = []) {
  const slug = worldCupGroupSlug(letter)
  return groupCategories.find(c => c.slug === slug) ?? null
}
